import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { HaikuPage } from "@/tools/syllable-counter/pages/HaikuPage";

const PATH = "/syllable-counter/haiku";

export const Route = createFileRoute("/syllable-counter/haiku")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.syl_haiku_meta_title() },
      { name: "description", content: m.syl_haiku_meta_description() },
      { property: "og:title", content: m.syl_haiku_meta_title() },
      { property: "og:description", content: m.syl_haiku_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.syl_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.syl_tool_name(),
              item: localeUrl(`/syllable-counter`),
            },
            {
              "@type": "ListItem",
              position: 3,
              name: m.syl_nav_haiku(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: m.syl_haiku_faq1_q(),
              acceptedAnswer: { "@type": "Answer", text: m.syl_haiku_faq1_a() },
            },
            {
              "@type": "Question",
              name: m.syl_haiku_faq2_q(),
              acceptedAnswer: { "@type": "Answer", text: m.syl_haiku_faq2_a() },
            },
            {
              "@type": "Question",
              name: m.syl_haiku_faq3_q(),
              acceptedAnswer: { "@type": "Answer", text: m.syl_haiku_faq3_a() },
            },
            {
              "@type": "Question",
              name: m.syl_haiku_faq4_q(),
              acceptedAnswer: { "@type": "Answer", text: m.syl_haiku_faq4_a() },
            },
          ],
        }),
      },
    ],
  }),
  component: HaikuPage,
});
